// @core/api/endpoints/workflow/update_environment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineEnvironmentResponse,
  UpdateEnvironmentRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Update environment
 * Updates environment credential bindings and variables.
 */
export async function UpdateEnvironment(
  environment_id: string,
  data: UpdateEnvironmentRequest,
  options?: RequestOptions
): Promise<PipelineEnvironmentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/environments/:environment_id`;
  requestPath = requestPath.replace(':environment_id', encodeURIComponent(environment_id));
  const requestOptions = options;
  return client.put<PipelineEnvironmentResponse>(requestPath, data, requestOptions);
}
